var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculatePurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5858_77204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2ZM12.6667 12.6667H3.33333V3.33333H12.6667V12.6667Z",
    fill: "#3333B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 5.14648H4.1665V6.14648H7.49984V5.14648Z",
    fill: "#3333B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 10.5H8.6665V11.5H11.9998V10.5Z",
    fill: "#3333B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 8.83203H8.6665V9.83203H11.9998V8.83203Z",
    fill: "#3333B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 12.0007H6.33333V10.6673H7.66667V9.66732H6.33333V8.33398H5.33333V9.66732H4V10.6673H5.33333V12.0007Z",
    fill: "#3333B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39319 7.3L10.3332 6.36L11.2732 7.3L11.9799 6.59333L11.0399 5.64667L11.9799 4.70667L11.2732 4L10.3332 4.94L9.39319 4L8.68652 4.70667L9.62652 5.64667L8.68652 6.59333L9.39319 7.3Z",
    fill: "#3333B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5858_77204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatePurple);
export default __webpack_public_path__ + "static/media/calculate-purple.293934cbff629b9f69c9b33837eab748.svg";
export { ForwardRef as ReactComponent };